var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9512 1.24991C16.065 0.908687 15.9762 0.532488 15.7218 0.278156C15.4675 0.0238232 15.0913 -0.0649849 14.7501 0.0487559L0.649323 4.74901C0.29207 4.8681 0.0389402 5.18704 0.00409145 5.562C-0.0307579 5.93696 0.159259 6.29709 0.488447 6.47997L4.805 8.87806C5.17562 9.08396 5.63783 9.01922 5.93763 8.71943L9.00718 5.64987C9.37803 5.27903 9.97928 5.27903 10.3501 5.64987C10.721 6.02071 10.721 6.62196 10.3501 6.9928L7.28056 10.0624C6.98077 10.3621 6.91603 10.8244 7.12193 11.195L9.52003 15.5116C9.70291 15.8407 10.063 16.0308 10.438 15.9959C10.813 15.9611 11.1319 15.7079 11.251 15.3507L15.9512 1.24991Z",
    fill: "#111827"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon2);
export default __webpack_public_path__ + "static/media/sendIcon2.94fe0a925808360c9cf832b019861983.svg";
export { ForwardRef as ReactComponent };